<template>
  <div class="px-10">
    <v-row>
      <v-col>
        <v-icon medium>
          mdi-account-group
        </v-icon>
        <span class="font-16 font-weight-bold mx-2">Approve On Behalf Scopes</span>
      </v-col>
    </v-row>
  
    <v-row
      v-if="loading"
      no-gutters
    >
      <v-col>
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-col>
    </v-row>

    <div v-else>
      <v-row v-if="edit">
        <v-col v-if="employeeLoading">
          <v-progress-linear
            indeterminate
            color="primary"
          />
        </v-col>
        <v-col
          v-else
          cols="12"
        >
          <v-autocomplete
            v-model="selectedEmployees"
            data-vv-name="selectedEmployees"
            data-vv-as="employees"
            :items="employees"
            multiple
            chips
            hide-no-data
            hide-selected
            item-text="person.name"
            item-value="employee_uid"
            deletable-chips
            label="Employees"
            :loading="employeeLoading"
          />
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col>
          <v-row
            v-if="approveOnBehalfScopes.length > 0"
            no-gutters
          >
            <v-col
              v-for="(employee, index) in approveOnBehalfScopes"
              :key="index"
              cols="12"
            >
              {{ index + 1 }}. {{ ((employee.employee || {}).person || {}).name }}
            </v-col>
          </v-row> 
          <v-row
            v-else
            no-gutters
          >
            <v-col cols="12">
              No Restriction
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <v-card-actions v-if="$hasPermissionTo(['update user roles'])">
      <v-spacer />
      <v-btn
        v-if="!edit"
        color="primary"
        @click="editForm"
      >
        Edit
      </v-btn>
      <div v-else>
        <v-btn
          :disabled="progressing"
          text
          @click="edit = false"
        >
          Cancel
        </v-btn>
        <v-btn          
          :loading="progressing"
          color="hrissecondary"
          class="white--text"
          @click="submitForm"
        >
          Update
        </v-btn>
      </div>
    </v-card-actions>
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        loading: false,
        employeeLoading: false,
        progressing: false,
        edit: false,
        employees: [],
        approveOnBehalfScopes: [],
        selectedEmployees: [],
      }
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadData()
          }
        },
      },
    },
    methods: {
      loadData () {
        this.loading = true

        this.$api.approveOnBehalfScopes().list(this.employeeUid)
          .then(res => {
            this.approveOnBehalfScopes = _.orderBy(res.data, ['employee.person.name'], ['asc'])

            this.loading = false
          })
      },
      loadEmployees () {
        this.$api.employees().list('?with=notResigned')
          .then(res => {
            this.employees = _.orderBy(res.data, ['person.name'], ['asc'])
            this.employeeLoading = false
          })
      },
      editForm () {
        this.employeeLoading = true
        this.loadEmployees()
        this.selectedEmployees = this.approveOnBehalfScopes.map(scope => scope.employee_uid)
 
        this.edit = true
      },
      submitForm () {
        this.progressing = true

        this.$api.approveOnBehalfScopes().update(this.employeeUid, this.prepareFormData())
          .then(response => {
            if (response.status >= 200 && response.status < 300) {
              this.loadData()

              this.edit = false

              this.$snack({
                message: response.data.status,
              })
            }
          })
          .catch((e) => {
            this.$snack({ 
              color: 'error',
              message: e.response.data.message,
            })
          })
          .then(() => {
            this.progressing = false
          })
      },
      prepareFormData () {
        return {
          employees: this.selectedEmployees,
        }
      },
    },
  }
</script>

<style scoped>
.font-16{
  font-size:16px;
}
</style>
